import { createStore } from 'vuex'

import appState from './appState';
import langState from './langState';

export default createStore({
  state: {
  },
  getters: {
    cookieName: state => state.app.cookieName,
    langType: state => state.lang.langType,
    prompt: state => state.app.prompt,
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    app: appState,
    lang: langState,
  }
})
